import api from "./api";

export type AssinaturaStatus = "rascunho" | "aguardando_assinatura" | "assinado" | "recusado" | "cancelado" | "expirado" | "importado";
export type SignatarioStatus = "pendente" | "visualizado" | "assinado" | "recusado";

export interface SignatarioInput {
  nome: string;
  email: string;
  papel?: string;
  documento?: string;
  telefone?: string;
  usuarioId?: string;
  ordem?: number;
}

export interface SignatarioResumo {
  id: string;
  nome: string;
  email: string;
  papel?: string | null;
  status: SignatarioStatus;
  ordem: number;
  assinadoEm?: string | null;
}

export interface DocumentoAssinatura {
  id: string;
  projetoId: string;
  titulo: string;
  descricao: string | null;
  arquivoUrl: string;
  arquivoNome: string;
  arquivoHash: string;
  arquivoTamanho: number;
  arquivoFinalUrl: string | null;
  arquivoFinalHash: string | null;
  textoConsentimento: string | null;
  status: AssinaturaStatus;
  importado: boolean;
  codigoVerificacao: string;
  expiraEm: string | null;
  finalizadoEm: string | null;
  criadoEm: string;
  signatarios?: SignatarioResumo[];
  eventos?: Array<{ id: string; tipo: string; criadoEm: string; ip?: string | null; userAgent?: string | null; detalhes?: string | null; signatarioId?: string | null }>;
  criador?: { id: string; nome: string; email: string };
}

export async function listarDocumentosProjeto(projetoId: string) {
  const r = await api.get(`/projetos/${projetoId}/assinaturas`);
  return r.data.data as DocumentoAssinatura[];
}

export async function buscarDocumento(id: string) {
  const r = await api.get(`/assinaturas/${id}`);
  return r.data.data as DocumentoAssinatura;
}

export async function criarDocumento(projetoId: string, params: {
  file: File;
  titulo: string;
  descricao?: string;
  importado?: boolean;
  textoConsentimento?: string;
  signatarios?: SignatarioInput[];
}) {
  const fd = new FormData();
  fd.append("file", params.file, params.file.name);
  fd.append("titulo", params.titulo);
  if (params.descricao) fd.append("descricao", params.descricao);
  if (params.importado) fd.append("importado", "true");
  if (params.textoConsentimento) fd.append("textoConsentimento", params.textoConsentimento);
  if (params.signatarios?.length) fd.append("signatarios", JSON.stringify(params.signatarios));
  const r = await api.post(`/projetos/${projetoId}/assinaturas`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return r.data.data as DocumentoAssinatura;
}

export async function enviarParaAssinatura(id: string) {
  const r = await api.post(`/assinaturas/${id}/enviar`);
  return r.data.data as DocumentoAssinatura;
}

export async function cancelarDocumento(id: string) {
  await api.post(`/assinaturas/${id}/cancelar`);
}

export async function listarSignatarios(id: string) {
  const r = await api.get(`/assinaturas/${id}/signatarios`);
  return r.data.data as Array<SignatarioResumo & { tokenAcesso: string }>;
}

// === Públicas (sem auth) ===

export interface PortalAssinatura {
  documento: {
    id: string;
    titulo: string;
    descricao: string | null;
    arquivoUrl: string;
    arquivoHash: string;
    textoConsentimento: string | null;
    status: AssinaturaStatus;
    codigoVerificacao: string;
  };
  signatario: {
    id: string;
    nome: string;
    email: string;
    documento: string | null;
    papel: string | null;
    status: SignatarioStatus;
    assinadoEm?: string | null;
    recusadoEm?: string | null;
  };
}

export async function carregarPortal(token: string) {
  const r = await api.get(`/assinar/${token}`);
  return r.data.data as PortalAssinatura;
}
export async function visualizarPortal(token: string) {
  await api.post(`/assinar/${token}/visualizar`);
}
export async function assinarPortal(token: string, dados: { documento?: string; aceitouConsentimento: boolean }) {
  await api.post(`/assinar/${token}/assinar`, dados);
}
export async function recusarPortal(token: string, motivo?: string) {
  await api.post(`/assinar/${token}/recusar`, { motivo });
}
export async function verificarPorCodigo(codigo: string) {
  const r = await api.get(`/verificar/${encodeURIComponent(codigo)}`);
  return r.data.data;
}
